import React, { useEffect, useState } from 'react'
import {
   Box,
   Button,
   FormControl,
   Grid,
   IconButton,
   InputAdornment,
   Paper,
   TextField
} from '@material-ui/core'
import { MuiPickersUtilsProvider, TimePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import { Autocomplete } from '@material-ui/lab'
import { Controller, useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import isNull from 'lodash/isNull'

import DatePickerField from '../../form/DatePickerField'
import GestionAprendizajeButton from './components/GestionAprendizajeButton'
import NavigationButtonTop from './components/NavigationButtonTop'
import SelectAndApplyQuestionnarie from './components/SelectAndApplyQuestionnarie'
import PortalModal, { usePortalModal } from 'components/commons/PortalModal'
import TooltipInputError from 'components/toolTip/ToolTipInputError'

import { getFromApi, postToApi, putToApi } from 'actions'
import { useStateValue } from 'context/store'
import { useApiRequest } from 'utils/customHooks/useApiRequest'
import utils from 'utils/utils'
import { setTime, duplicateRoles, sendQuestToAPIMapper } from './utils'
import initialquestionnaireStyles from './styles'
import iconQuestionnarie from '../assets/icons/psychology_alt.png'
import {
   closeSpinnerAction,
   openSpinnerAction
} from 'context/reducers/openSpinnerReducer'
import { openSnackBarAction } from 'context/reducers/openSnackbarReducer'

const defaultValues = {
   name: '',
   description: '',
   subdomainId: '',
   applicationId: '',
   finalDate: null,
   userType: '',
   roleId: [],
   groupId: [],
   functionality: [],
   initialDate: null,
   time: null
}

const minDate = moment().startOf('day')

function CreateQuestionnaireForm({ setViewQuestionnarie }) {
   let history = useHistory()
   const [{ questionaries }, dispatch] = useStateValue()
   const classes = initialquestionnaireStyles()
   const [allActiveSubdomains, setAllActiveSubdomains] = useState([])
   const [allActiveApplications, setAllActiveApplications] = useState({})
   const [questionaryData, setQuestionaryData] = useState({})
   const [allRolesAndGroup, setAllRolesAndGroup] = useState([])
   const [funcionalities, setFuncionalities] = useState([])
   const [filterRoles, setFilterRoles] = useState([])
   const { params, onClose, setModal } = usePortalModal()
   const [rolList, setRolList] = useState([])

   const getDataQuestionnaire = async () => {
      try {
         const url = `${process.env.REACT_APP_QUESTIONNAIRE_API}/questionnaire/${questionaries.questionaries?.id}`
         const ques = await getFromApi(url)
         setQuestionaryData(ques)
         dispatch({ type: 'SaveQuest', questionaries: ques })
         setValue('name', ques?.name)
         setValue('description', ques?.description)
         setValue('subdomainId', ques?.subdomain)
         setValue('applicationId', ques?.application)
         setValue('finalDate', setTime(ques?.finalDate))
         setValue('initialDate', setTime(ques?.initialDate))

         setTimeout(() => {
            setValue('time', setTime(ques.initialDate))
         }, 2000)
      } catch (error) {
         console.error('Error fetching questionnaire data:', error)
      }
   }

   useEffect(() => {
      const fetchData = async () => {
         await getDataQuestionnaire()
      }
      questionaries?.questionaries?.id && fetchData()
   }, [])

   const {
      watch,
      handleSubmit,
      reset,
      control,
      formState: { errors, isValid },
      setValue,
      getValues
   } = useForm({
      defaultValues
   })

   const [selectedSubdomain, selectedApplication, functionality, initialDate] =
      watch(['subdomainId', 'applicationId', 'functionality', 'initialDate'])

   const clearFields = fields =>
      fields.forEach(field => setValue(field, field == 'roleId' ? [] : ''))

   function goToMundoMutual() {
      history.push('/dashboard/mutual-world')
   }
   const putQuestionnarie = async payload => {
      const URL_QUESTIONNARIE = `${process.env.REACT_APP_QUESTIONNAIRE_API}/questionnaire/${questionaryData.id}`
      dispatch(openSpinnerAction())
      try {
         const dataPost = await putToApi(URL_QUESTIONNARIE, payload)
         dispatch({ type: 'SaveQuest', questionaries: dataPost })
         dispatch(closeSpinnerAction())
         await dispatch(
            openSnackBarAction(
               `Se guardó correctamente el cuestionario`,
               'Info'
            )
         )
         setViewQuestionnarie('view-create-questionnaire')
      } catch (error) {
         dispatch(closeSpinnerAction())
         dispatch(
            openSnackBarAction(
               ` Ocurrio un error al intentar crear el cuestionario: ${error?.data?.message}`
            )
         )
      }
   }

   const postQuestionnarie = async payload => {
      const URL_QUESTIONNARIE = `${process.env.REACT_APP_QUESTIONNAIRE_API}/questionnaire`
      dispatch(openSpinnerAction())
      try {
         const dataPost = await postToApi(URL_QUESTIONNARIE, payload)
         dispatch({ type: 'SaveQuest', questionaries: dataPost })
         dispatch(closeSpinnerAction())
         setViewQuestionnarie('view-create-questionnaire')
         dispatch(
            openSnackBarAction(`Se guardo correctamente el formulario`, 'Info')
         )
      } catch (error) {
         dispatch(closeSpinnerAction())
         dispatch(
            openSnackBarAction(
               ` Ocurrio un error al intentar crear el cuestionario: ${error?.data?.message}`
            )
         )
      }
   }
   const compareDates = (initialDate, finalDate) => {
      const dateInitial = new Date(initialDate)
      const dateFinal = new Date(finalDate)
      const newDate1 = new Date(
         dateInitial.getFullYear(),
         dateInitial.getMonth(),
         dateInitial.getDate()
      )
      const newDate2 = new Date(
         dateFinal.getFullYear(),
         dateFinal.getMonth(),
         dateFinal.getDate()
      )

      return newDate1 <= newDate2
   }

   const onSubmit = dataPayload => {
      if (!compareDates(dataPayload.initialDate, dataPayload.finalDate)) {
         dispatch(
            openSnackBarAction(
               ` Ocurrio un error al intentar crear el cuestionario: La fecha de vencimiento es inferior a la fecha de publicación`
            )
         )
         return
      }
      const data = sendQuestToAPIMapper(dataPayload)
      if (Object.entries(questionaryData).length !== 0) {
         putQuestionnarie(data)
         setViewQuestionnarie('view-create-questionnaire')
         return
      }
      postQuestionnarie(data)
   }

   // ------------- Fetch all Initial Active Subdomains  -----------------
   async function _getAllActiveSubdomains() {
      const url = `${process.env.REACT_APP_SUBDOMAIN_API}/subdomains/active`
      const searchedSubdomains = await getFromApi(url)
      setAllActiveSubdomains(searchedSubdomains)
   }

   const getAllActiveSubdomains = useApiRequest(
      _getAllActiveSubdomains,
      'Aplicaciones: Consultar Subdominios Activos'
   )

   const subdomainsGrouped = allActiveSubdomains.map(option => {
      const firstLetter = option.name[0]?.toUpperCase()
      return {
         firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
         ...option
      }
   })

   // ------------- Fetch all Initial Applications for subdomain  -----------------
   async function _getAllActiveApplications() {
      const url = `${process.env.REACT_APP_AUTHORIZATION_API}/user/subdomain/${selectedSubdomain?.code}/applications`
      const activeApplications = await getFromApi(url)

      setAllActiveApplications(activeApplications)
   }

   const getAllActiveApplications = useApiRequest(
      _getAllActiveApplications,
      'Funcionalidades: Consultar Aplicaciones Activas'
   )

   // ------------- Fetch all roles and group, for applicaction  -----------------
   async function _getAllRolesAndGroup() {
      const url = `${process.env.REACT_APP_SUBDOMAINS_MUTUAL_WORLD_API}/user/functionality/rol-group/FunctionalitiesCode`
      const payload = [{ functionalityCode: functionality?.code }]
      const allRAndG = await postToApi(url, payload)
      setAllRolesAndGroup(await allRAndG)
      if (
         Object.entries(questionaryData).length !== 0 &&
         filterRoles.length == 0
      ) {
         const filteredObjects = allRAndG?.roles.filter(item =>
            questionaryData.roles.includes(item.id)
         )
         const filteredObjectsGroups = allRAndG?.groups.filter(item =>
            questionaryData.groups.includes(item.id)
         )
         setValue('roleId', filteredObjects)
         setValue('groupId', filteredObjectsGroups)
         setRolList(filteredObjects)
         setFilterRoles(filteredObjects)
         return
      }
      const duplicatedRoles = duplicateRoles(allRAndG, rolList)
      setValue('roleId', duplicatedRoles)
      setRolList(duplicatedRoles)
   }

   const getAllRolesAndGroup = useApiRequest(
      _getAllRolesAndGroup,
      'RolesAndGroup: Consultar roles and grupos'
   )

   async function _getAllFuncionalities() {
      const url = `${process.env.REACT_APP_FUNCTIONALITIES_API}/functionalities/search/applicationCode/`
      const payload = [{ applicationCode: selectedApplication?.code }]

      const funcionalitiesByApplication = await postToApi(url, payload)
      setFuncionalities(funcionalitiesByApplication)
      if (Object.entries(questionaryData).length !== 0) {
         const filteredObject = funcionalitiesByApplication.find(
            item => item.id === questionaryData.functionality
         )
         setValue('functionality', filteredObject || null)
      }
   }

   const getAllFuncionalities = useApiRequest(
      _getAllFuncionalities,
      'Funcionalidades: Consultar Funcionalidades Activas'
   )

   const isEditMode = Object.entries(questionaryData).length !== 0
   const showExitModal = backButton => {
      const message = `Señor usuario, usted detendrá la ${
         isEditMode ? 'edición' : 'creacion'
      } del cuestionario, ¿Desea continuar?`
      const onConfirm = backButton
         ? () => setViewQuestionnarie('')
         : goToMundoMutual
      setModal({ message, onConfirm })
   }

   const calcMinDate = () =>
      moment(new Date(), 'DD-MM-YYYY').add(15, 'days').startOf('day')

   useEffect(() => {
      getAllActiveSubdomains()
   }, [])

   useEffect(() => {
      getAllActiveApplications()
   }, [selectedSubdomain])

   useEffect(() => {
      if (!functionality) return
      getAllRolesAndGroup()
   }, [functionality])

   useEffect(() => {
      getAllFuncionalities()
   }, [selectedApplication])

   useEffect(() => {}, [rolList])

   useEffect(() => {
      if (!questionaries.questionaries) {
         reset()
         setQuestionaryData({})
      }
   }, [questionaries])

   const filterOptionRol = options => {
      const roles = getValues('roleId')
      const arraySinDuplicados = options.filter(
         opcion => !roles?.some(rol => rol?.id === opcion?.id)
      )
      return arraySinDuplicados
   }
   const filterOptionFuncionality = options => {
      const arraySinDuplicados = options?.filter(
         opcion =>
            !functionality?.some(
               functionalitie => functionalitie?.id === opcion?.id
            )
      )
      return arraySinDuplicados
   }

   return (
      <Grid
         style={{
            width: '90%',
            height: '100%',
            display: 'flex',
            padding: '0 3rem',
            gap: '2rem'
         }}
      >
         <NavigationButtonTop
            setShowComfirmationModal={() => showExitModal()}
            isConfirmationModal
            isButtonBack
            setView={() => showExitModal('backbutton')}
         />
         <div
            style={{
               width: '100%',
               display: 'flex',
               flexDirection: 'column',
               alignContent: 'center',
               justifyContent: 'center',
               padding: '0 7rem'
            }}
         >
            <Box
               sx={{
                  width: '80%',
                  display: 'flex',
                  gap: '1rem',
                  justifyContent: 'space-between',
                  alignContent: 'center',
                  height: '40px',
                  margin: '1rem'
               }}
            >
               <div>
                  <GestionAprendizajeButton
                     setViewQuestionnarie={setViewQuestionnarie}
                  />
               </div>
            </Box>
            <Paper className={classes.paper}>
               <Box
                  sx={{
                     width: '70%',
                     display: 'flex',
                     gap: '1rem',

                     alignContent: 'center',
                     alignItems: 'center',
                     height: '40px',
                     padding: '2rem 4rem'
                  }}
               >
                  <div className={classes.iconQuestionnarie}>
                     <img src={iconQuestionnarie} alt="" />
                  </div>{' '}
                  <h3>
                     {isEditMode ? 'Editar cuestionario' : 'Crear cuestionario'}
                  </h3>
               </Box>
               <form onSubmit={handleSubmit(onSubmit)}>
                  <Grid
                     style={{ padding: '1rem 7rem', marginBottom: '1.5rem' }}
                  >
                     <FormControl fullWidth>
                        <Controller
                           name="name"
                           control={control}
                           rules={{
                              required: {
                                 value: true,
                                 message: 'El titulo es obligatorio'
                              },
                              maxLength: {
                                 value: 150,
                                 message:
                                    'El Número de Caracteres NO es válido. '
                              }
                           }}
                           render={({
                              field: { value, onChange, onBlur },
                              fieldState: { error }
                           }) => (
                              <TextField
                                 label="Título *"
                                 value={value}
                                 onChange={onChange}
                                 onBlur={onBlur}
                                 error={errors?.name}
                                 variant="outlined"
                                 InputProps={{
                                    endAdornment: errors?.name?.type ===
                                       'maxLength' && (
                                       <TooltipInputError
                                          title={`El número permitido de caracteres es de máximo 150.`}
                                       />
                                    )
                                 }}
                                 margin="normal"
                                 helperText={
                                    errors?.name ? errors.name?.message : ''
                                 }
                              />
                           )}
                        />
                     </FormControl>
                     <FormControl fullWidth>
                        <Controller
                           name="description"
                           control={control}
                           rules={{
                              maxLength: {
                                 value: 200,
                                 message:
                                    'El Número de Caracteres NO es válido.'
                              }
                           }}
                           render={({
                              field: { value, onChange, onBlur },
                              fieldState: { error }
                           }) => (
                              <TextField
                                 label="Descripción"
                                 value={value}
                                 onChange={onChange}
                                 onBlur={onBlur}
                                 error={errors?.description}
                                 variant="outlined"
                                 margin="normal"
                                 multiline
                                 InputProps={{
                                    endAdornment: errors?.description?.type ===
                                       'maxLength' && (
                                       <TooltipInputError
                                          title={`El número permitido de caracteres es de máximo 200.`}
                                       />
                                    )
                                 }}
                                 helperText={
                                    errors?.description
                                       ? errors.description?.message
                                       : ''
                                 }
                              />
                           )}
                        />
                     </FormControl>
                     <Box
                        sx={{
                           display: 'flex',
                           alignItems: 'flex-start',
                           gap: '2.5rem',
                           width: '100%',
                           marginTop: 15
                        }}
                     >
                        <FormControl fullWidth>
                           <Controller
                              name="subdomainId"
                              control={control}
                              rules={{
                                 required: {
                                    value: true,
                                    message:
                                       'Seleccionar subdominio es obligatorio'
                                 }
                              }}
                              render={({
                                 field: { ref, onChange, ...field }
                              }) => (
                                 <Autocomplete
                                    // value={subdomainObject}
                                    value={selectedSubdomain}
                                    options={subdomainsGrouped.sort(
                                       (a, b) =>
                                          -b.firstLetter.localeCompare(
                                             a.firstLetter
                                          )
                                    )}
                                    getOptionSelected={(option, value) =>
                                       option.id === value.id
                                    }
                                    getOptionLabel={option =>
                                       option.name
                                          ? utils.capitalizeFirstLetter(
                                               option.name
                                            )
                                          : option?.name
                                    }
                                    groupBy={option => option.firstLetter}
                                    onChange={(_, data) => {
                                       clearFields([
                                          'applicationId',
                                          'functionality',
                                          'roleId',
                                          'groupId'
                                       ])
                                       onChange(data)
                                    }}
                                    name="subdomainId"
                                    renderInput={params => (
                                       <TextField
                                          {...params}
                                          {...field}
                                          inputRef={ref}
                                          getOptionSelected={(option, value) =>
                                             option.id === value.id
                                          }
                                          label="Seleccionar subdominio *"
                                          variant="outlined"
                                          error={errors?.subdomainId}
                                          helperText={
                                             errors?.subdomainId
                                                ? errors.subdomainId?.message
                                                : ''
                                          }
                                       />
                                    )}
                                 />
                              )}
                           />
                        </FormControl>
                        <FormControl fullWidth>
                           <Controller
                              name="applicationId"
                              control={control}
                              rules={{
                                 required: {
                                    value: true,
                                    message:
                                       'Seleccionar aplicación es obligatorio'
                                 }
                              }}
                              render={({
                                 field: { ref, onChange, ...field }
                              }) => (
                                 <Autocomplete
                                    options={allActiveApplications}
                                    getOptionLabel={option =>
                                       option?.name || ''
                                    }
                                    renderOption={option => (
                                       <span key={option?.id}>
                                          {option?.name}
                                       </span>
                                    )}
                                    value={selectedApplication}
                                    onChange={(_, data) => {
                                       clearFields([
                                          'functionality',
                                          'roleId',
                                          'groupId'
                                       ])
                                       onChange(data)
                                    }}
                                    renderInput={params => (
                                       <TextField
                                          {...params}
                                          {...field}
                                          inputRef={ref}
                                          label="Seleccionar aplicación *"
                                          variant="outlined"
                                          error={errors?.applicationId}
                                          helperText={
                                             errors?.applicationId
                                                ? errors.applicationId?.message
                                                : ''
                                          }
                                          // error={invalid.application}
                                       />
                                    )}
                                 />
                              )}
                           />
                        </FormControl>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           alignItems: 'flex-start',
                           gap: '2.5rem',
                           width: '100%'
                        }}
                     >
                        <FormControl fullWidth>
                           <Controller
                              name="functionality"
                              control={control}
                              rules={{
                                 required: {
                                    value: true,
                                    message:
                                       'Seleccionar funcionalidad es obligatorio'
                                 }
                              }}
                              render={({
                                 field: { ref, onChange, value, ...field }
                              }) => (
                                 <Autocomplete
                                    name="functionality"
                                    // filterOptions={filterOptionFuncionality}
                                    options={funcionalities ?? []}
                                    getOptionLabel={option =>
                                       option?.name ?? ''
                                    }
                                    renderOption={option => (
                                       <span
                                          style={{ fontSize: '12px' }}
                                          key={option?.id}
                                       >
                                          {option?.name}
                                       </span>
                                    )}
                                    groupBy={option => option?.module?.name}
                                    value={value || []}
                                    onChange={(_, data) => {
                                       onChange(data)
                                       setValue('roleId', [])
                                       setValue('groupId', [])
                                    }}
                                    renderInput={params => (
                                       <TextField
                                          {...params}
                                          {...field}
                                          inputRef={ref}
                                          margin="normal"
                                          getOptionSelected={option =>
                                             option.id === value.id
                                          }
                                          label="Seleccionar funcionalidad *"
                                          variant="outlined"
                                          error={errors?.functionality}
                                          helperText={
                                             errors?.functionality
                                                ? errors.functionality?.message
                                                : ''
                                          }
                                       />
                                    )}
                                 />
                              )}
                           />
                        </FormControl>
                        <FormControl fullWidth>
                           <Controller
                              name="roleId"
                              control={control}
                              render={({
                                 field: { ref, onChange, value, ...field }
                              }) => (
                                 <Autocomplete
                                    multiple
                                    name="roleId"
                                    options={allRolesAndGroup?.roles ?? []}
                                    filterOptions={filterOptionRol}
                                    getOptionLabel={option =>
                                       option?.name || ''
                                    }
                                    renderOption={option => (
                                       <span key={option?.id}>
                                          {option?.name}
                                       </span>
                                    )}
                                    // value={filterRoles.length == 0 ? [] : filterRoles}
                                    // defaultValue={filterRoles}
                                    // value={filterRoles}
                                    // value={roleId}
                                    value={value || []}
                                    onChange={(_, data) => {
                                       onChange(data)
                                       setRolList(data)
                                       setValue('roleId', data) // Actualiza el valor usando setValue
                                    }}
                                    renderInput={params => (
                                       <TextField
                                          {...params}
                                          {...field}
                                          inputRef={ref}
                                          margin="normal"
                                          label="Seleccionar Rol"
                                          variant="outlined"
                                          error={errors?.roleId}
                                          helperText={
                                             errors?.roleId
                                                ? errors.roleId?.message
                                                : ''
                                          }
                                       />
                                    )}
                                 />
                              )}
                           />
                        </FormControl>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           alignItems: 'flex-start',
                           gap: '2.5rem',
                           width: '100%'
                        }}
                     >
                        <FormControl fullWidth>
                           <Controller
                              name="groupId"
                              control={control}
                              render={({
                                 field: { ref, onChange, value, ...field }
                              }) => (
                                 <Autocomplete
                                    multiple
                                    name="groupId"
                                    options={allRolesAndGroup?.groups ?? []}
                                    getOptionLabel={option =>
                                       option?.name || ''
                                    }
                                    renderOption={option => (
                                       <span key={option?.id}>
                                          {option?.name}
                                       </span>
                                    )}
                                    // value={formData.application}
                                    value={value || []}
                                    onChange={(_, data) => {
                                       onChange(data)
                                       setValue('groupId', data) // Actualiza el valor usando setValue
                                    }}
                                    renderInput={params => (
                                       <TextField
                                          {...params}
                                          {...field}
                                          inputRef={ref}
                                          margin="normal"
                                          label="Seleccionar grupo"
                                          variant="outlined"
                                          error={errors?.groupId}
                                          helperText={
                                             errors?.groupId
                                                ? errors.groupId?.message
                                                : ''
                                          }
                                       />
                                    )}
                                 />
                              )}
                           />
                        </FormControl>
                        <FormControl fullWidth>
                           <Controller
                              name="finalDate"
                              control={control}
                              rules={{
                                 required: true,
                                 validate: {
                                    min: date =>
                                       moment(date).isSameOrAfter(calcMinDate())
                                 }
                              }}
                              render={({ field: { onChange, value } }) => (
                                 <DatePickerField
                                    handleChange={onChange}
                                    formValue={value}
                                    minDate={calcMinDate()}
                                    minDateMessage="Fecha de vencimiento tiene que ser mínimo 15 días después de la fecha actual"
                                    fieldLabel="Fecha de vencimiento *"
                                    {...(errors?.finalDate?.type === 'required'
                                       ? {
                                            error: true,
                                            helperText:
                                               'Seleccionar fecha de vencimiento es obligatorio'
                                         }
                                       : {})}
                                 />
                              )}
                           />
                        </FormControl>
                     </Box>

                     <Box
                        sx={{
                           display: 'flex',
                           alignItems: 'center',
                           gap: '2.5rem',
                           width: '47.5%'
                        }}
                     >
                        <h3>Programar publicación</h3>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           alignItems: 'baseline',
                           gap: '2.5rem',
                           width: '47.5%'
                        }}
                     >
                        <Controller
                           name="initialDate"
                           control={control}
                           rules={{
                              validate: {
                                 min: date => {
                                    isNull(date) ||
                                       moment(date).isSameOrAfter(minDate)
                                 }
                              }
                           }}
                           render={({ field: { onChange, value } }) => (
                              <DatePickerField
                                 handleChange={onChange}
                                 formValue={value}
                                 minDate={minDate}
                                 minDateMessage="La fecha no puede ser menor a la fecha actual"
                                 fieldLabel="Fecha de inicio"
                              />
                           )}
                        />

                        {initialDate && (
                           <div style={{ padding: '1.5rem 0 1rem' }}>
                              {/* // <FormControl fullWidth> */}
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                 <Controller
                                    name="time"
                                    control={control}
                                    rules={{
                                       required: {
                                          value: initialDate,
                                          message: 'La hora es obligatoria'
                                       }
                                    }}
                                    render={({ field }) => (
                                       <TimePicker
                                          {...field}
                                          error={errors?.time}
                                          format="h:00 a"
                                          label="Hora *"
                                          // variant="inline"
                                          inputVariant="outlined"
                                          // ampm={false}
                                          views={['hours']}
                                          // clearable
                                          helperText={
                                             errors?.time
                                                ? errors.time?.message
                                                : ''
                                          }
                                          autoOk
                                          InputAdornmentProps={{
                                             position: 'end'
                                          }}
                                          InputProps={{
                                             endAdornment: (
                                                <InputAdornment position="end">
                                                   <IconButton>
                                                      <AccessTimeIcon />
                                                   </IconButton>
                                                </InputAdornment>
                                             )
                                          }}
                                       />
                                    )}
                                 />
                              </MuiPickersUtilsProvider>
                           </div>
                        )}
                     </Box>
                  </Grid>
                  <Box
                     sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignContent: 'center',
                        height: '70px',
                        width: '100%',
                        background: '#3264DC0F 0% 0% no-repeat'
                     }}
                  >
                     <div
                        style={{
                           width: '100%',
                           display: 'flex',
                           gap: '1rem',
                           justifyContent: 'flex-end',
                           alignContent: 'center',
                           padding: '1rem 7rem'
                        }}
                     >
                        <Button
                           variant="outlined"
                           color="primary"
                           onClick={() => showExitModal('backbutton')}
                        >
                           CANCELAR
                        </Button>
                        <Button
                           variant="contained"
                           color="primary"
                           type="submit"
                           endIcon={<ArrowForwardIcon fontSize="medium" />}
                        >
                           GUARDAR Y CONTINUAR
                        </Button>
                     </div>
                  </Box>
               </form>
            </Paper>
         </div>
         <PortalModal params={params} onClose={onClose} />
      </Grid>
   )
}

export default CreateQuestionnaireForm
